<template>
  <div class="app-content" :class="$router.currentRoute.name">
    <div class="md-layout">
      <div class="md-layout-item profile-content"></div>
    </div>
  </div>

</template>

<script>
import HelpersMixin from './HelpersMixin.vue';

export default {
  name: "Profile",
  mixins: [HelpersMixin],
  mounted() {
    var _self = this;
    let highlighted = document.querySelector('.region-highlighted');
    let content = document.querySelector('.region-content');
    this.$el.querySelector('.profile-content').append(highlighted);
    this.$el.querySelector('.profile-content').append(content);
    let errorEl = content.querySelector('.error');
    this.$el.querySelector('a.button.change-password').onclick = function() {
      let passChangeWrapper = _self.$el.querySelector('.password-change-wrapper');
      let profileInfoWrapper = _self.$el.querySelector('.profile-info-wrapper');
      passChangeWrapper.classList.remove('hide');
      passChangeWrapper.classList.add('show');
      profileInfoWrapper.classList.remove('show');
      profileInfoWrapper.classList.add('hide');
      var setHeight = () => {
        document.querySelector('#catch-user-profile-form').style.height = content.querySelector('.password-change-wrapper').offsetHeight + 60 + 'px';
        _self.$el.querySelector('.profile-info-wrapper').style.marginTop = '-' + _self.$el.querySelector('.profile-info-wrapper').offsetHeight + 'px';
        _self.$el.querySelector('.password-change-wrapper').style.height = _self.$el.querySelector('.password-change-wrapper').offsetHeight + 'px';

      }

      setHeight()

    };
    this.$el.querySelector('a.back-user-profile-info').onclick = function() {
      let passChangeWrapper = _self.$el.querySelector('.password-change-wrapper');
      let profileInfoWrapper = _self.$el.querySelector('.profile-info-wrapper');
      passChangeWrapper.classList.remove('show');
      passChangeWrapper.classList.add('hide');
      profileInfoWrapper.classList.remove('hide');
      profileInfoWrapper.classList.add('show');
      var setHeight = () => {
        document.querySelector('#catch-user-profile-form').style.height = document.querySelector('.profile-info-wrapper').offsetHeight  + 'px';
        _self.$el.querySelector('.profile-info-wrapper').style.marginTop = '0px';
        _self.$el.querySelector('.password-change-wrapper').style.height = _self.$el.querySelector('.password-change-wrapper').offsetHeight + 'px';
      };

      setHeight()

    };
    this.$el.querySelectorAll('a.profile-cancel').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        if (
          this.hasRole('content_manager') ||
          this.hasRole('content_creator') || 
          this.hasRole('subgroup_administrator') || 
          this.hasRole('group_administrator') || 
          this.hasRole('coach')
          ['subgroup_administrator', 'group_administrator', 'coach', 'content_manager', 'content_creator'].indexOf(window.drupalSettings.user.role) !== -1
        ) {
          window.location.href = '/';
        }
        else {
          window.location.href = '/learner';
        }
      });
    });
    let actions;
    let messages;
    setTimeout(() => {
      if (errorEl && errorEl.getAttribute('type') == 'password') {
        actions = document.querySelector('.password-change-wrapper').querySelector('.form-actions');
        messages = document.querySelector('.messages__wrapper');
        if (messages) {
          actions.insertBefore(messages, actions.firstChild);
          messages.classList.add('show');
          messages.addEventListener("transitionend", ()=> {
            this.$el.querySelector('a.button.change-password').dispatchEvent(new Event('click'));
          });
          setTimeout(() => {
            messages.classList.add('animate');
          }, 200);
        }
        this.$el.querySelector('a.button.change-password').dispatchEvent(new Event('click'));
      }
      else {
        actions = document.querySelector('.profile-info-wrapper').querySelector('.form-actions');
        messages = document.querySelector('.messages__wrapper');
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        let isResetPassword = urlParams.has('pass-reset-token');
        if (messages) {
          actions.insertBefore(messages, actions.firstChild);
          messages.classList.add('show');
          messages.addEventListener("transitionend", ()=> {
            if (!isResetPassword) {
              this.$el.querySelector('a.back-user-profile-info').dispatchEvent(new Event('click'));
            }
          });
          setTimeout(() => {
            messages.classList.add('animate');
          }, 200);
        }
        if (!isResetPassword) {
          this.$el.querySelector('a.back-user-profile-info').dispatchEvent(new Event('click'));
        }
        if (isResetPassword) {
          this.$el.querySelector('a.button.change-password').dispatchEvent(new Event('click'));
        }
      }
    }, 200)
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss" scoped>

  // .md-layout-item:last-child {
  //   max-width: 315px;
  //   @media (max-width: $breakpoint-tablet) {
  //     max-width: 0px;
  //   }
  // }
  .md-layout-item {
    max-width: 100%;
  }
</style>
<style lang="scss">
.page-profile {
  .region-highlighted {
    .messages__wrapper {
      display: none;

    }
  }
  .region-content {
    .messages__wrapper {
      //max-height: 0;
      transition: .7s;
      transition-delay: .1s;
      overflow: hidden;
      opacity: 0;
      &.show {
        display: block;
        &.animate {
          max-height: 300px;
          opacity: 1;
        }
      }
    }
  }
}
</style>
